import FAQItem from "../components/questions/Questions"
import Button from "../components/WAbutton/Button";
import MyServices from "./FifthScreen";
import styles from "./SixthScreen.module.css"

const SixthScreen = () => {
  return (
    <>
         <div className={styles.title} id="טיפולים">הטיפולים שלי</div>
         <div className={styles.description}>ריכזתי עבורך את כל הטיפולים שניתן לקבל אצלי בקליניקה - לחצ/י על הטיפול הרלוונטי עבורך לעוד פרטים עליו</div>
         <MyServices/>
      <div className={styles.title}>אתן שואלות ואני עונה</div>
      <div className={styles.description}>
        יוצא לי לשמוע מכן הרבה שאלות וחשוב לי לספק לכן את המענה עליהן גם כשאני לא זמינה תמיד - תקליקי על כל שאלה שרלוונטית אלייך
      </div>
      <FAQItem 
        question="מה מבדיל את הקורס שלך מקורסים אחרים בתחום הריסים?" 
        answer="ההבדל העיקרי בשיטה שלי הוא היחס האישי – כל תלמידה מקבלת ליווי לאורך כל הדרך ובנוסף - הדרכות vip אחת על אחת, ואצלי הטכניקה מותאמת אישית לסגנון העבודה שלה. אני לא עובדת לפי תבניות אחידות, אלא מתאימה את השיטה לכל תלמידה. בנוסף, אני שמה דגש חזק על פרקטיקה, על ידע מעמיק בטכניקות מתקדמות, ועל היבטים של בריאות הריסים הטבעיים. אני רואה המון בנות שיוצאות לא מוכנות מקורסים, ואני כאן לשנות את זה."
      />
      
      <FAQItem 
        question="השוק היום מפוצץ במתחרות, איך דווקא אני אצליח מכולן?" 
        answer="כשלומדים בצורה נכונה, מפתחים סגנון עבודה אישי ומקבלים את הכלים המקצועיים הנכונים - יש סיכוי גבוה להצלחה. בקורס את תלמדי טכניקה בהתאמה אישית אלייך, מה שיעזור לך למשוך אלייך לקוחות ויוביל אותך ליהנות מהעשייה ולפתח סגנון ייחודי משל עצמך. אני לא מוכרת חלומות - צריך להתמיד, לתרגל ולהשקיע, אבל עם הבסיס המקצועי הנכון והליווי הצמוד, את בהחלט יכולה להצליח ולמלא יומן."
      />
      


      
      <FAQItem 
        question="כמה זמן לוקח עד שרואים תוצאות אחרי הקורס?" 
        answer="ההשקעה בתחום הזה יכולה לחזור תוך זמן מאוד קצר למי שעובדת נכון ובצורה מקצועית. חשוב להבין שבניית קריירה היא תהליך - זה לא קורה בן לילה. עם זאת, עם העבודה הנכונה, הנחישות והיכולת להעניק טיפול מקצועי ברמה גבוהה, אפשר בהחלט לראות תוצאות מהירות יחסית. הסוד הוא להתחיל, להתמיד, ולתת שירות מעולה - ואז הלקוחות הראשונות מביאות איתן עוד לקוחות, וככה ממלאים את היומן ובונים מוניטין."
      />
      

      <FAQItem 
  question="אני חוששת שאני לא מספיק טובה וכישרונית בתחום הריסים, האם אוכל להצליח בכל זאת?" 
  answer="חשוב לי שתדעי שלרוב, הצלחה בתחום הריסים קשורה הרבה יותר לעבודה קשה, התמדה ולימוד נכון מאשר לכישרון מולד. אני רואה בכל יום נשים שלא האמינו בעצמן בהתחלה והפכו למקצועניות מבוקשות. כשאת לומדת בשיטה המותאמת אישית אלייך, בקצב שלך ועם הליווי הצמוד שלי, את מקבלת ביטחון מקצועי שמאפשר לך להתגבר על חששות ולבנות את הקריירה שאת רוצה. אני מאמינה שעם הכלים הנכונים, כל אחת יכולה להצליח!"
/>

<FAQItem 
  question="עברתי כבר קורס ריסים בעבר ואני עדיין באותו מקום היום, למה שהפעם יהיה שונה?" 
  answer="אני שומעת את זה לא מעט, ואני מבינה את התסכול. ההבדל העיקרי בשיטה שלי הוא שאני לא מסתפקת בללמד טכניקה אחידה לכולן - אני מתאימה את שיטת העבודה ספציפית אלייך ולסגנון שלך. בנוסף, אני נותנת ליווי צמוד גם אחרי הקורס, מה שנותן לך רשת ביטחון כשאת יוצאת לשוק. אשמח לשמוע מה לא עבד לך בקורס הקודם, ממה התאכזבת ואיך החוויה שלך הייתה, כדי שאוכל להתאים את ההדרכה בדיוק לצרכים שלך. לא תישארי לבד בתהליך!"
/>




<FAQItem 
  question="אני עובדת במשרה מלאה ומפחדת מהמעבר לעצמאות, האם אפשר לעשות את המעבר בהדרגה?" 
  answer="בהחלט! למעשה, המון בנות מתחילות את הקריירה בתחום הריסים במקביל לעבודה הקיימת שלהן. זו גישה חכמה שמאפשרת לך לבנות בסיס לקוחות ולהתחזק מקצועית בלי הלחץ הכלכלי. אני אעזור לך לבנות תכנית עבודה מדורגת, שתאפשר לך להתחיל עם כמה שעות בשבוע ולהרחיב בהדרגה. ככה את יכולה לראות תוצאות, לבנות ביטחון מקצועי, ולוודא שהתחום באמת מתאים לך לפני שאת עושה את הקפיצה המלאה לעצמאות. הגמישות היא אחת היתרונות הגדולים של המקצוע הזה (ובנוסף, אלו שמשקיעות - מהר מאוד עוזבות את העבודה כי הן כבר התחילו לצבור לקוחות חוזרות)"
/>
      <Button text="אין לי עוד שאלות בואי נדבר!"/>
    </>
  );
};

export default SixthScreen;